import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bar", "text", "passwordField"];

  connect() {
    if (this.hasPasswordFieldTarget) {
      this.passwordFieldTarget.addEventListener("input", this.check.bind(this));
    }

    if (this.hasBarTarget) {
      this.createBorders();
      // Fetch localized strength messages
      this.messages = JSON.parse(document.getElementById('password-strength-messages').dataset.messages);
    }
  }

  check(event) {
    const password = event.target.value;
    const strength = this.calculateStrength(password);

    this.updateStrengthBar(strength);
    this.updateStrengthText(strength);
  }

  calculateStrength(password) {
    let strength = 0;

    if (password.match(/[a-z].*[a-z].*[a-z]/)) strength++; // At least 3 lowercase letters
    if (password.match(/[A-Z].*[A-Z]/)) strength++; // At least 2 uppercase letters
    if (password.match(/\d/)) strength++; // At least one digit
    if (password.match(/[\#\?\!\@\$\%\^\&\*\-]/)) strength++; // At least one special character
    if (password.length >= 12) strength++; // Minimum length

    return strength;
  }

  updateStrengthBar(strength) {
    const widths = ["0%", "20%", "40%", "60%", "80%", "100%"];
    const strengthClasses = [
      "password-strength-fill--very-weak",
      "password-strength-fill--weak",
      "password-strength-fill--moderate",
      "password-strength-fill--strong",
      "password-strength-fill--very-strong",
    ];

    this.barTarget.style.width = widths[strength];
    this.barTarget.className = `password-strength-fill ${strengthClasses[strength - 1] || ""}`;
  }

  updateStrengthText(strength) {
    const strengthClasses = [
      "password-strength-text--very-weak",
      "password-strength-text--weak",
      "password-strength-text--moderate",
      "password-strength-text--strong",
      "password-strength-text--very-strong"
    ];

    this.textTarget.textContent = this.messages[strength - 1] || "";
    this.textTarget.className = `password-strength-text ${strengthClasses[strength - 1] || ""}`;
  }

  createBorders() {
    const container = this.barTarget.parentElement;
    container.classList.add("password-strength-container");

    for (let i = 0; i < 4; i++) {
      const border = document.createElement("div");
      border.classList.add("password-strength-divider");
      border.style.insetInlineStart = `${(i + 1) * 20}%`;
      container.appendChild(border);
    }
  }

  toggleVisibility(event) {
    const passwordField = event.currentTarget.closest(".relative").querySelector("input[type='password'], input[type='text']");
    passwordField.type = passwordField.type === "password" ? "text" : "password";
  }
}
